import React, {
  useMemo,
} from 'react'

import DatabaseContext from './DatabaseContext'
import useDatabaseContext from './Database.logic/useDatabaseContext'

const DatabaseProvider = ({ children }) => {
  // console.log('DatabaseProvider.js')
  const databaseContextData = useDatabaseContext()

  return useMemo(() => (
    <DatabaseContext.Provider value={databaseContextData}>
      { children }
    </DatabaseContext.Provider>
  ), [databaseContextData]) // eslint-disable-line
}

export default DatabaseProvider
